export enum UserRolesPersian {
  ProvinceGuildRoomAdmin = "ادمین اتاق اصناف استان",
  CountyGuildRoomAdmin = "ادمین اتاق اصناف شهرستان",
  UserReal = "کاربر حقیقی",
  UserLegal = "کاربر حقوقی",
  UnionSecretariat = "دبیرخانه اتحادیه",
}
